<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <b-form-group class="mr-1 mb-2xl-0">
            <b-button
              v-b-modal.modal-create-link
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-primary"
              block
              @click="addPromotion"
            >
              สร้างลิ้งเข้าเกม
            </b-button>
          </b-form-group>

          <div>
            <b-row>
              <b-col>
                <div class="d-flex justify-content-end">
                  <b-form-select
                    v-model="search_type"
                    class="d-inline-block mr-1"
                    :options="search_type_option"
                  />

                  <b-form-input
                    v-model="search_val"
                    :disabled="!search_type"
                    class="d-inline-block mr-1"
                    placeholder="ค้นหา..."
                  />

                  <b-form-select
                    v-model="filter_spins"
                    class="d-inline-block mr-1"
                    :options="spin_options"
                  />

                  <b-button
                    v-b-modal.filter-game-modal
                    variant="outline-secondary"
                    block
                    class="d-flex mr-1 w-full justify-content-center align-items-center"
                  >
                    <!-- <img
                      v-if="filter_game"
                      :src="getGameImage(filter_game)"
                      :alt="getGameText(filter_game)"
                      class="mr-1"
                      style="width: 14px; height: 14px; border-radius: 2px; "
                    /> -->
                    {{ getGameText(filter_game) || "เกม (ทั้งหมด)" }}
                  </b-button>

                  <!-- Modal เลือกเกม -->
                  <b-modal
                    id="filter-game-modal"
                    title="เลือกเกม"
                    size="lg"
                    hide-footer
                  >
                    <div class="row">
                      <div class="col-md-3">
                        <b-card
                          class="game-card"
                          style="cursor: pointer; transition: transform 0.2s"
                          :class="{ 'border-primary': filter_game === null }"
                          @click="selectFilterGame(null)"
                        >
                          <div class="text-center">
                            <div
                              style="
                                width: 80px;
                                height: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: #f8f9fa;
                                border-radius: 8px;
                                margin: 0 auto;
                              "
                            >
                              <i
                                class="fas fa-gamepad"
                                style="font-size: 30px; color: #6c757d"
                              />
                            </div>
                            <h6 class="mb-0">
                              ทั้งหมด
                            </h6>
                          </div>
                        </b-card>
                      </div>
                      <div
                        v-for="game in pg_game_options.filter((g) => g.value)"
                        :key="game.value"
                        class="col-md-3"
                      >
                        <b-card
                          class="game-card"
                          style="cursor: pointer; transition: transform 0.2s"
                          :class="{
                            'border-primary': filter_game === game.value,
                          }"
                          @click="selectFilterGame(game.value)"
                        >
                          <div class="text-center">
                            <img
                              :src="getGameImage(game.value)"
                              :alt="game.text"
                              class="mb-2"
                              style="
                                width: 80px;
                                height: 80px;
                                object-fit: cover;
                                border-radius: 8px;
                              "
                            >
                            <h6 class="mb-0">
                              {{ game.text }}
                            </h6>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </b-modal>

                  <flat-pickr
                    v-model="start_date"
                    type="date"
                    class="d-inline-block mr-1 form-control"
                  />

                  <flat-pickr
                    v-model="end_date"
                    type="date"
                    class="d-inline-block mr-1 form-control"
                  />

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon"
                    block
                    @click="getPromotionHistory()"
                  >
                    <feather-icon icon="SearchIcon" />
                    ค้นหา
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card-body>

      <b-table
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>

        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            >
            {{
              scope.emptyFiltered ? "No matching records found" : "ไม่พบข้อมูล"
            }}
          </div>
        </template>

        <template #cell(link)="data">
          <div class="text-nowrap">
            <b-button
              variant="gradient-success"
              size="sm"
              @click="copyGameLink(data.item.link)"
            >
              <i class="fas fa-copy" /> คัดลอกลิ้ง
            </b-button>
          </div>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'active' ? 'success' : 'secondary'"
          >
            {{ data.item.status === "active" ? "ใช้งานได้" : "หมดอายุ" }}
          </b-badge>
        </template>

        <template #cell(created_at)="data">
          {{ formatDate(data.item.created_at) }}
        </template>

        <template #cell(spinCount)="data">
          <b-badge variant="light-warning">
            <feather-icon
              icon="GiftIcon"
            />
            {{ data.item.spinCount }}
          </b-badge>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getPromotionHistory()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getPromotionHistory()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

      <!-- Modal สร้างลิ้งเข้าเกม -->
      <b-modal
        id="modal-create-link"
        title="สร้างลิ้งเข้าเกม"
        ok-title="สร้างลิ้ง"
        @ok="createGameLink"
      >
        <b-overlay
          :show="show2"
          variant="transparent"
          opacity="0.99"
          blur="5px"
          rounded="sm"
        >
          <template #overlay>
            <div class="text-center">
              <b-icon-controller
                font-scale="3"
                animation="cylon"
              />
              <p id="cancel-label">
                กรุณารอสักครู่...
              </p>
            </div>
          </template>

          <validation-observer ref="createLinkRules">
            <!-- ค้นหายูส -->
            <b-form-group label="ค้นหายูสเซอร์">
              <div class="d-flex">
                <b-form-input
                  v-model="search_username"
                  class="col-9 mr-1"
                  type="text"
                  placeholder="กรอกยูสเซอร์เนมหรือเบอร์โทรศัพท์"
                  @enter="searchUser()"
                />
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="col-2.5 btn-icon"
                  block
                  @click="searchUser()"
                >
                  <feather-icon icon="SearchIcon" />
                  ค้นหา
                </b-button>
              </div>
              <div>
                <span
                  v-if="!selected_member && user_searched"
                  style="color: red"
                >
                  ไม่พบข้อมูลยูสเซอร์
                </span>
                <span
                  v-if="selected_member && user_searched"
                  style="color: green"
                >
                  {{ selected_member.name }} {{ selected_member.surname }} :
                  {{ selected_member.username }}
                </span>
              </div>
            </b-form-group>

            <div v-if="selected_member && user_searched">
              <!-- เลือกจำนวนฟรีสปิน -->
              <b-form-group label="จำนวนฟรีสปิน">
                <b-form-select
                  v-model="selected_spins"
                  :options="free_spin_options"
                  required
                />
              </b-form-group>

              <!-- เลือกเกม -->
              <b-form-group label="เกม">
                <b-button
                  v-b-modal.game-select-modal
                  variant="outline-primary"
                  block
                  class="text-left d-flex align-items-center"
                >
                  <img
                    v-if="selected_game"
                    :src="getGameImage(selected_game)"
                    :alt="selected_game_text"
                    class="mr-2"
                    style="
                    width: 30px;
                    height: 30px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                  >
                  <span>{{ selected_game_text || "เลือกเกม" }}</span>
                </b-button>
              </b-form-group>
            </div>

            <!-- Modal เลือกเกม -->
            <b-modal
              id="game-select-modal"
              title="เลือกเกม"
              size="lg"
              hide-footer
            >
              <div class="row">
                <div
                  v-for="game in pg_game_options.filter((g) => g.value)"
                  :key="game.value"
                  class="col-md-3"
                >
                  <b-card
                    no-body
                    @click="selectGame(game)"
                  >
                    <div class="text-center m-1 cursor-pointer">
                      <img
                        :src="getGameImage(game.value)"
                        :alt="game.text"
                        class="mb-2"
                        style="
                          width: 80px;
                          height: 80px;
                          object-fit: cover;
                          border-radius: 8px;
                        "
                      >
                      <h6 class="mb-0">
                        {{ game.text }}
                      </h6>
                    </div>
                  </b-card>
                </div>
              </div>
            </b-modal>

            <!-- แสดงลิ้งที่สร้างแล้ว -->
            <b-form-group
              v-if="generated_link"
              label="ลิ้งเข้าเกม"
            >
              <b-input-group>
                <b-form-input
                  v-model="generated_link"
                  readonly
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-primary"
                    @click="copyGameLink(generated_link)"
                  >
                    <i class="fas fa-copy" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </validation-observer>
        </b-overlay>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'
import {
  BBadge,
  BRow,
  BCol,
  BOverlay,
  BIconController,
  BInputGroupPrepend,
  BInputGroupAppend,
  BModal,
  BCard,
  BTable,
  BAvatar,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BButton,
  BCardBody,
  VBToggle,
  VBTooltip,
  BDropdown,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    flatPickr,
    BRow,
    BBadge,
    BCol,
    BInputGroupPrepend,
    BInputGroupAppend,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BButton,
    BCardBody,
    BOverlay,
    BIconController,
    ValidationProvider,
    ValidationObserver,
    VBTooltip,
    BDropdown,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      pgproGameList: [],
      required,
      show: false,
      show2: false,
      user_searched: false,
      selected_member: null,
      search_username: '',
      selected_spins: null,
      selected_game: null,
      selected_game_text: null,
      generated_link: '',

      // Filter options
      search_type: null,
      search_val: '',
      filter_spins: null,
      filter_game: null,
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),

      search_type_option: [
        { value: null, text: 'เลือกประเภทการค้นหา' },
        { value: 'username', text: 'ยูสเซอร์เนม' },
        { value: 'tel', text: 'เบอร์โทรศัพท์' },
      ],

      spin_options: [
        { value: null, text: 'จำนวนฟรีสปิน (ทั้งหมด)' },
        { value: 1, text: '1 ฟรีสปิน' },
        { value: 2, text: '2 ฟรีสปิน' },
        { value: 5, text: '5 ฟรีสปิน' },
      ],

      game_options: [
        { value: null, text: 'เกม (ทั้งหมด)' },
        { value: 'fortune-tiger', text: 'Fortune Tiger' },
        { value: 'fortune-ox', text: 'Fortune Ox' },
        { value: 'gates-of-olympus', text: 'Gates of Olympus' },
        { value: 'sweet-bonanza', text: 'Sweet Bonanza' },
      ],

      free_spin_options: [
        { value: null, text: 'เลือกจำนวนฟรีสปิน' },
        { value: 1, text: '1 ฟรีสปิน' },
        { value: 2, text: '2 ฟรีสปิน' },
        { value: 5, text: '5 ฟรีสปิน' },
      ],

      pg_game_options: [
      ],

      // Table settings
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],

      // Table fields
      fields: [
        { key: 'index', label: 'ลำดับ' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'tel', label: 'เบอร์โทรศัพท์' },
        { key: 'gameName', label: 'เกม' },
        { key: 'spinCount', label: 'จำนวนฟรีสปิน' },
        // { key: "status", label: "สถานะ" },
        { key: 'link', label: 'ลิ้งเข้าเกม' },
        { key: 'created_at', label: 'วันที่สร้าง' },
      ],

      items: [],
    }
  },
  mounted() {
    this.getPromotionHistory()
    this.getPgproGames()
  },
  methods: {
    selectFilterGame(gameValue) {
      this.filter_game = gameValue
      this.$bvModal.hide('filter-game-modal')
    },

    getGameText(gameValue) {
      if (!gameValue) return null
      const game = this.pg_game_options.find(g => g.value === gameValue)
      return game ? game.text : null
    },
    async getPgproGames() {
      try {
        const { data } = await this.$http.get('/profreespin/gamelist')
        this.pgproGameList = data.Data || []
        // console.log(this.pgproGameList);

        this.pg_game_options = [
          { value: null, text: 'เลือกเกม' },
          ...this.pgproGameList.map(game => ({
            value: game.gameId,
            text: game.name,
            img: game.img,
          })),
        ]
      } catch (error) {
        console.log(error)
      }
    },

    selectGame(game) {
      this.selected_game = game.value
      this.selected_game_text = game.text
      this.$bvModal.hide('game-select-modal')
    },

    getGameImage(gameValue) {
      const game = this.pgproGameList.find(
        g => (g.gameId) === gameValue,
      )
      return game ? game.img : '/images/games/default.png'
    },
    addPromotion() {
      this.selected_member = null
      this.search_username = ''
      this.selected_spins = null
      this.selected_game = null
      this.selected_game_text = null
      this.generated_link = ''
      this.user_searched = false
    },

    async searchUser() {
      if (!this.search_username) {
        this.$swal({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณากรอกยูสเซอร์เนมหรือเบอร์โทรศัพท์',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
        return
      }

      this.show2 = true
      try {
        const response = await this.$http.post('/profreespin/search-user', {
          search: this.search_username,
        })

        if (response.data.success) {
          this.selected_member = response.data.FindUser
          this.user_searched = true
        } else {
          this.selected_member = null
          this.user_searched = true
        }
      } catch (error) {
        console.error(error)
        this.SwalError('เกิดข้อผิดพลาดในการค้นหายูสเซอร์')
      }
      this.show2 = false
    },

    async createGameLink() {
      if (!this.selected_member) {
        this.$swal({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาค้นหาและเลือกยูสเซอร์ก่อน',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
        return false
      }

      if (!this.selected_spins || !this.selected_game) {
        this.$swal({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาเลือกจำนวนฟรีสปินและเกม',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
        return false
      }

      this.show2 = true
      try {
        const payload = {
          uid: this.selected_member.id,
          username: this.selected_member.username,
          gameId: this.selected_game,
          spinCount: this.selected_spins,
        }

        const response = await this.$http.post(
          '/profreespin/create-link',
          payload,
        )

        if (response.data.success) {
          this.generated_link = response.data.link

          this.$swal({
            icon: 'success',
            title: 'สร้างลิ้งสำเร็จ',
            html: `
          <div >
            <input type="text" class="form-control" value="${this.generated_link}" readonly id="generated-link-input">
          </div>
        `,
            showCancelButton: false,
            confirmButtonText: 'คัดลอกลิ้ง',
            cancelButtonText: 'ปิด',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          }).then(result => {
            if (result.isConfirmed) {
              this.copyGameLink(this.generated_link)
            }
          })

          // รีเฟรชข้อมูลตาราง
          this.getPromotionHistory()
        } else {
          this.SwalError(
            response.data.message || 'เกิดข้อผิดพลาดในการสร้างลิ้ง',
          )
        }
      } catch (error) {
        console.error(error)
        this.SwalError('เกิดข้อผิดพลาดในการสร้างลิ้งเข้าเกม')
      }
      this.show2 = false
      return true
    },

    async createRedisData() {
      try {
        const redisKey = `proFreeSpin:${this.selected_game}:${this.selected_member._id}`
        const redisData = {
          rounds: this.selected_spins,
          member_id: this.selected_member._id,
          game_name: this.selected_game,
          created_at: new Date().toISOString(),
        }

        await this.$http.post('/promotion/create-redis-freespin', {
          key: redisKey,
          data: redisData,
        })
      } catch (error) {
        console.error('Error creating Redis data:', error)
      }
    },

    generateRandomToken() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      const segments = [4, 4, 4, 12] // XXXX-XXXX-XXXX-XXXXXXXXXXXX

      return segments
        .map(length => {
          let result = ''
          for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length))
          }
          return result
        })
        .join('-')
    },

    async getPromotionHistory() {
      this.show = true
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
          search_type: this.search_type,
          search_val: this.search_val,
          filter_spins: this.filter_spins,
          filter_game: this.filter_game,
          start_date: this.start_date,
          end_date: this.end_date,
        }

        const response = await this.$http.post(
          '/profreespin/history',
          params,
        )

        if (response.data.success) {
          this.items = response.data.data
          this.totalRows = response.data.total
        } else {
          this.items = []
          this.totalRows = 0
        }
      } catch (error) {
        console.error(error)
        this.SwalError('เกิดข้อผิดพลาดในการโหลดข้อมูล')
      }
      this.show = false
    },

    copyGameLink(link) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(link)
          .then(() => {
            this.$swal({
              icon: 'success',
              title: 'สำเร็จ',
              text: 'คัดลอกลิ้งเรียบร้อยแล้ว',
              timer: 1500,
              showConfirmButton: false,
            })
          })
          .catch(() => {
            this.fallbackCopyTextToClipboard(link)
          })
      } else {
        this.fallbackCopyTextToClipboard(link)
      }
    },

    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.$swal({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'คัดลอกลิ้งเรียบร้อยแล้ว',
          timer: 1500,
          showConfirmButton: false,
        })
      } catch (err) {
        this.$swal({
          icon: 'error',
          title: 'ผิดพลาด',
          text: 'ไม่สามารถคัดลอกลิ้งได้',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
      }

      document.body.removeChild(textArea)
    },

    formatDate(date) {
      return moment(date).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },

    SwalError(message) {
      this.$swal({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: message,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
